import React from 'react';
import TodoList from './TodoList';
import Footer from './Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className='App-1'>
      <h1>ToDo List</h1>
<TodoList/>
</div>
<Footer/>
    </div>
  

  );

}

export default App;
